/* unplugin-vue-components disabled */import { render } from "./Login-.vue?vue&type=template&id=5195e3ed"
import script from "./Login-.vue?vue&type=script&lang=js"
export * from "./Login-.vue?vue&type=script&lang=js"

import "./Login-.vue?vue&type=style&index=0&id=5195e3ed&lang=css"

import exportComponent from "C:\\Users\\Administrator\\IdeaProjects\\haoma517-cust\\haoma517-customer-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__